import systemLogoSrc        from '@img/logos/system_logo.webp'
import menuLogoSrc          from '@img/logos/menu_logo.webp'
import menuLogoWhiteSrc     from '@img/logos/omnia_ems_logo_white.png'
import loginLogoSrc         from '@img/logos/omnia_ems_logo.png'
import developerLogoSrc     from '@img/logos/logo_4evolve.webp'
import dashboardSplashSrc   from '@img/logos/dashboard_splash.webp'
import underConstructionSrc from '@img/logos/under_construction_logo.webp'
import noPermissionSrc      from '@img/logos/no_permission_logo.webp'
import warningIconSrc       from '@img/icons/warning_icon.png'
import startSplashSrc       from '@img/gfx/login-splash.jpg'
import pageSplashSrc        from '@img/gfx/page-splash.jpg'

export const systemLogo            = systemLogoSrc
export const menuLogo              = menuLogoSrc
export const menuLogoWhite         = menuLogoWhiteSrc
export const loginLogo             = loginLogoSrc
export const developerLogo         = developerLogoSrc
export const startSplash           = startSplashSrc
export const pageSplash            = pageSplashSrc
export const dashboardSplash       = dashboardSplashSrc
export const underConstructionLogo = underConstructionSrc
export const noPermissionLogo      = noPermissionSrc
export const warningIcon           = warningIconSrc

export const appName       = 'Omnia - Enterprise Management System'
export const appCaption    = 'Omnia 1.0.0'
export const bgTextureExt  = "webp"
export const bgTextureName = "textures/bg_texture_";
export const bgTexture     = bgTextureExt;

export const nbpUrl = 'https://api.nbp.pl/api/exchangerates/rates/A';